export const lang = {
  hello:"hello",
  example:'example',
  httpGET:'HTTP GET',
  httpPOST:'HTTP POST',
  httpDELETE:'HTTP DELETE',
  httpPUT:'HTTP PUT',
};